export const configs = {
  VITE_APP_BASE_URL: process.env.VITE_APP_BASE_URL,
  VITE_APP_MOO_URL: process.env.VITE_APP_MOO_URL,
  FE_BASE_URL: () => window.location.origin,
  VITE_APP_CLUSTER: process.env.VITE_APP_CLUSTER,
  VITE_APP_ASSET_BASE_URL: process.env.VITE_APP_ASSET_BASE_URL,
  VITE_APP_DATADOG_CLIENT_TOKEN: process.env.VITE_APP_DATADOG_CLIENT_TOKEN,
};
